"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var memoize = require('lodash.memoize');
exports.default = function (resolver) { return function (target, key, descriptor) {
    if (typeof descriptor.value !== 'function') {
        throw new Error('Memoization can be applied only to methods');
    }
    descriptor.value = memoize(descriptor.value, resolver);
    return descriptor;
}; };
//# sourceMappingURL=index.js.map